import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Loading } from 'core';
import { withStore } from 'core/store';
import ZendeskTicketSection from './components/zendesk-ticket-section';
import SendgridTicketSection from './components/sendgrid-ticket-section';
import Five9TicketSection from './components/five9-ticket-section';

const Tickets = ({
  store: {
    account: {
      fname,
      lname,
      email,
      phoneNumber,
      getAllTickets,
      getZdTickets,
      getSendgridTickets,
      getFive9Tickets,
      fetchTickets,
      fetchAccount,
      accountLoading,
      ticketsLoading
    }
  }
}) => {
  // @NOTE this is seperate because its kind of slow, and not rendered when the page loads
  useEffect(() => {
    if (!getAllTickets() && !accountLoading) {
      if (fname && lname && email && phoneNumber) {
        fetchTickets();
      }
    }
  }, [fetchAccount, accountLoading, fname, lname, email, phoneNumber, fetchTickets, getAllTickets, getZdTickets]);

  if (ticketsLoading || accountLoading || !getAllTickets()) {
    return <Loading />;
  }
  return (
    <>
      <ZendeskTicketSection tickets={getZdTickets()} />
      <SendgridTicketSection tickets={getSendgridTickets()} />
      <Five9TicketSection tickets={getFive9Tickets()} />
    </>
  );
};

Tickets.propTypes = {
  store: PropTypes.object.isRequired
};
export default withStore(Tickets);
